import { render, staticRenderFns } from "./CreateLaboratorio.vue?vue&type=template&id=1ec056c7"
import script from "./CreateLaboratorio.vue?vue&type=script&lang=js"
export * from "./CreateLaboratorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports